'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002411 from "./presto.-Register-Page-View$$anon$11.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002413 from "./presto.-Register-Page-View$$anon$13.js";
import * as $j_presto$002etypes$0024$002dCompact$002dPlan$0024 from "./presto.types$-Compact-Plan$.js";
import * as $j_presto$002etypes$0024$002dPlan$002dCode$0024 from "./presto.types$-Plan-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterPageView$$anon$10() {
  this.bsx = null;
  this.bsp = null;
  this.bsq = false;
  this.bsy = null;
  this.bsz = false;
  this.bsC = null;
  this.bsv = null;
  this.bsw = false;
  this.bsr = null;
  this.bss = false;
  this.bst = null;
  this.bsu = false;
  this.bsA = false;
  this.bsB = false;
  this.bsx = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bsC = "CompactPlan";
}
export { $c_Lpresto_RegisterPageView$$anon$10 as $c_Lpresto_RegisterPageView$$anon$10 };
$p = $c_Lpresto_RegisterPageView$$anon$10.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterPageView$$anon$10;
/** @constructor */
function $h_Lpresto_RegisterPageView$$anon$10() {
}
export { $h_Lpresto_RegisterPageView$$anon$10 as $h_Lpresto_RegisterPageView$$anon$10 };
$h_Lpresto_RegisterPageView$$anon$10.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bsx;
});
$p.M = (function() {
  if ((!this.bsq)) {
    this.bsp = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bsq = true;
  }
  return this.bsp;
});
$p.O = (function() {
  if ((!this.bsz)) {
    this.bsy = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bsz = true;
  }
  return this.bsy;
});
$p.E = (function() {
  return this.bsC;
});
$p.t = (function() {
  if ((!this.bsw)) {
    this.bsv = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("features", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bsw = true;
  }
  return this.bsv;
});
$p.N = (function() {
  if ((!this.bss)) {
    this.bsr = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dPlan$002dCode$0024.$m_Lpresto_types$PlanCode$().adg(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002411.$c_Lpresto_RegisterPageView$$anon$11())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bss = true;
  }
  return this.bsr;
});
$p.Q = (function() {
  if ((!this.bsu)) {
    this.bst = new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002413.$c_Lpresto_RegisterPageView$$anon$13();
    this.bsu = true;
  }
  return this.bst;
});
$p.v = (function() {
  if ((!this.bsB)) {
    this.bsA = false;
    this.bsB = true;
  }
  return this.bsA;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee96) => ((p) => \u03b4scrutinee96.acV(p)))($j_presto$002etypes$0024$002dCompact$002dPlan$0024.$m_Lpresto_types$CompactPlan$())));
});
var $d_Lpresto_RegisterPageView$$anon$10 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterPageView$$anon$10, "presto.RegisterPageView$$anon$10", ({
  Qe: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_RegisterPageView$$anon$10 as $d_Lpresto_RegisterPageView$$anon$10 };
//# sourceMappingURL=presto.-Register-Page-View$$anon$10.js.map
